import { getServerEnvironment } from 'src/helper/getServerEnvironment';

import { gracefulFetch } from './gracefulFetch';

interface Props {
  state: {};
  values: {};
}

export const postFeedbackForm = async ({ state, values }: Props) => {
  let response: Response | null = null;

  try {
    response = await gracefulFetch({
      fetch: async () =>
        fetch(
          `https://${
            getServerEnvironment() === 'dev'
              ? 'dev.nect-frontend-website.int.svc.nect.com'
              : 'nect.com'
          }/api/feedback-form/`,
          {
            method: 'POST',
            headers: {
              'X-API-KEY': '79542dc7-587c-4d7f-9d3a-58b4420ba3e1',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              ...state,
              ...values
            })
          }
        )
    });
  } catch (e) {
    console.warn(e);
  }

  return response;
};
